/* ══════════════════════════════════════════════════════════════
   IPO Upcoming — Upcoming IPO List
   ══════════════════════════════════════════════════════════════ */

export interface IPOData {
    name: string;
    issueSize: number;
    priceRange: { min: number; max: number };
    openDate: string;
    closeDate: string;
    category: string;
    greyMarketPremium: number;
    recommendation: string;
}

export function renderIPOUpcoming(container: HTMLElement, ipos?: IPOData[]): void {
    const data: IPOData[] = ipos || [
        { name: 'Hexaware Tech', issueSize: 8700, priceRange: { min: 674, max: 710 }, openDate: 'Feb 28', closeDate: 'Mar 3', category: 'Book Built', greyMarketPremium: 45, recommendation: 'Subscribe' },
        { name: 'Dr Agarwal\'s Eye', issueSize: 3027, priceRange: { min: 382, max: 402 }, openDate: 'Mar 5', closeDate: 'Mar 7', category: 'Book Built', greyMarketPremium: 28, recommendation: 'Subscribe' },
        { name: 'Ather Energy', issueSize: 4500, priceRange: { min: 0, max: 0 }, openDate: 'Mar 10', closeDate: 'Mar 12', category: 'Book Built', greyMarketPremium: 0, recommendation: 'Wait' },
        { name: 'LG Electronics India', issueSize: 15000, priceRange: { min: 0, max: 0 }, openDate: 'TBD', closeDate: 'TBD', category: 'DRHP Filed', greyMarketPremium: 0, recommendation: 'Watch' },
    ];

    const cards = data.map(ipo => `
    <div class="ipo-card glass-card">
      <div class="ipo-header">
        <h4>${ipo.name}</h4>
        <span class="ipo-category-badge">${ipo.category}</span>
      </div>
      <div class="ipo-details">
        <div class="ipo-detail"><span>Issue Size</span><span>₹${(ipo.issueSize).toLocaleString('en-IN')} Cr</span></div>
        <div class="ipo-detail"><span>Price Band</span><span>${ipo.priceRange.max > 0 ? `₹${ipo.priceRange.min} - ₹${ipo.priceRange.max}` : 'TBD'}</span></div>
        <div class="ipo-detail"><span>Opens</span><span>${ipo.openDate}</span></div>
        <div class="ipo-detail"><span>Closes</span><span>${ipo.closeDate}</span></div>
        ${ipo.greyMarketPremium ? `<div class="ipo-detail"><span>GMP</span><span class="gmp-value">+₹${ipo.greyMarketPremium}</span></div>` : ''}
      </div>
      <div class="ipo-footer">
        <span class="ipo-rec ${ipo.recommendation.toLowerCase()}">${ipo.recommendation}</span>
      </div>
    </div>`).join('');

    container.innerHTML = `
    <div class="ipo-upcoming">
      <div class="card-header"><h3>🚀 Upcoming IPOs</h3></div>
      <div class="ipo-grid">${cards}</div>
    </div>`;
}
